import { render, staticRenderFns } from "./ReceiptsEdit.vue?vue&type=template&id=5cf48225&"
import script from "./ReceiptsEdit.vue?vue&type=script&lang=js&"
export * from "./ReceiptsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports